<template>
  <div>
    <v-card>
      <!-- Navigation -->
      <v-tabs
        v-model="tab"
        color--text="red"
        grow
      >
        <v-tabs-slider color="#e72b37" />
        <!-- Die Navigationsdaten kommen aus den headerItems -->
        <v-tab
          v-for="headerItem in headerItems"
          :key="headerItem"
          :disabled="
            !(
              headerItem === 'Dashboard' ||
              headerItem === 'Arbeitstage' ||
              headerItem === 'GAV spezifische Feiertage' ||
              headerItem === 'Zusätzliche Feiertage' ||
              headerItem === 'Feiertagsübersicht'
            )
          "
          style="color: #e72b37"
        >
          {{ headerItem }}
        </v-tab>
      </v-tabs>
      <!-- Content -->
      <v-tabs-items
        id="custom-tab-items"
        v-model="tab"
      >
        <v-tab-item
          v-for="(headerItem, index) in headerItems"
          :key="headerItem"
        >
          <resource-calendar-dashboard-tab
            v-if="tab === index && headerItem === 'Dashboard'"
            :preset-configuration-id="dashboardConfigurationId"
          />
          <!-- Component zur Arbeitszeit erfassung wird aufgrufen -->
          <work-days
            v-if="tab === index && headerItem === 'Arbeitstage'"
            :can-user-edit="canUserEdit"
          />
          <gav-holidays
            v-if="tab === index && headerItem === 'GAV spezifische Feiertage'"
            :can-user-edit="canUserEdit"
          />
          <additional-holidays
            v-if="tab === index && headerItem === 'Zusätzliche Feiertage'"
            :can-user-edit="canUserEdit"
          />
          <holiday-overview
            v-if="tab === index && headerItem === 'Feiertagsübersicht'"
            :can-user-edit="canUserEdit"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import WorkDays from "@/components/minimum.wage/pages/Holidays/Capture/WorkDays.vue";
import GavHolidays from "@/components/minimum.wage/pages/Holidays/Capture/GavHolidays.vue";
import AdditionalHolidays from "@/components/minimum.wage/pages/Holidays/Capture/AdditionalHolidays.vue";
import HolidayOverview from "@/components/minimum.wage/pages/Holidays/Capture/HolidayOverview.vue";
import ResourceCalendarDashboardTab from "@/components/resourceCalendar/tabs/ResourceCalendarDashboardTab.vue";

export default {
  components: {
    WorkDays,
    GavHolidays,
    AdditionalHolidays,
    HolidayOverview,
    ResourceCalendarDashboardTab,
  },
  data() {
    return {
      tab: null, //Um das Ausgewählte Tab zu hinterlegen
      headerItems: [
        "Dashboard",
        "Arbeitstage",
        "GAV spezifische Feiertage",
        "Zusätzliche Feiertage",
        "Feiertagsübersicht",
        "    ",
      ], //Werden die Navigationsdaten definiert
    };
  },
  computed: {
    dashboardConfigurationId() {
      const value = Number.parseInt(this.$route.params.editionsId, 10);
      return Number.isNaN(value) ? null : value;
    },
    canUserEdit() {
      return (
        (this.$IsUserInRole("VertragsmanagementVerwaltung") ||
          (this.$IsUserInRole("VertragsmanagementUniaVertragsverantworlich") &&
            this.$store.state.mindestLohnKonfiguration.Tenants.find(
              (x) => x.id == 4,
            ))) &&
        this.$IsUserInRole("ZuschlagsrechnerVerwaltung") &&
        this.$store.state.contractConfiguration.canUserEdit
      );
    },
  },
};
</script>

<style scoped></style>
